import * as React from "react";

import { AppInput } from "../../../ui-foundation/core";

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <AppInput
        type={type}
        className={className}
        ref={ref as React.Ref<any>}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
